import EventPublisher from "../utils/EventPublisher";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import AdvertisementAPIClient from "../client/AdvertisementAPIClient";
import Time from "../utils/Time";


class AdvertisementActions {

    constructor() {
        this.advertisementApiClient = new AdvertisementAPIClient();
        EventPublisher.subscribe(UIInteractionEvents.ADVERTISEMENT_CREATE_SAVE_SUBMITTED, this.handleAdvertisementSubmit);
        EventPublisher.subscribe(UIInteractionEvents.GET_MY_ADVERTISEMENTS, this.handleGetMyAdvertisements);
        EventPublisher.subscribe(UIInteractionEvents.OPEN_ADVERTISEMENT_CLICKED, this.handleOpenAdvertisementClicked);
        EventPublisher.subscribe(UIInteractionEvents.CLOSE_ADVERTISEMENT_CLICKED, this.handleCloseAdvertisementClicked);
        EventPublisher.subscribe(UIInteractionEvents.ADVERTISEMENT_VIEW_MOUNTED, this.handleGetAdvertisement);
        EventPublisher.subscribe(UIInteractionEvents.ADVERTISEMENT_EDIT_SET_ADVERTISEMENT_ID, this.handleGetAdvertisement);
        EventPublisher.subscribe(UIInteractionEvents.ADVERTISEMENT_EDIT_SAVE_SUBMITTED, this.handleUpdateAdvertisement);
        EventPublisher.subscribe(UIInteractionEvents.ADVERTISEMENT_BILLING_MOUNTED, this.handleLoadBilling);
        EventPublisher.subscribe(UIInteractionEvents.ADVERTISEMENT_BILLING_SELECTED_MONTH_CHANGED, this.handleLoadBilling);
    }

    handleGetMyAdvertisements = (topic, data) => {
        this.advertisementApiClient.getMyAdvertisements();
    };

    handleAdvertisementSubmit = (topic, data) => {
        this.advertisementApiClient.submitAdvertisement(data);
    };

    handleOpenAdvertisementClicked = (topic, data) => {
        this.advertisementApiClient.openAdvertisement(data.advertisementId);
    };

    handleCloseAdvertisementClicked = (topic, data) => {
        this.advertisementApiClient.closeAdvertisement(data.advertisementId);
    };

    handleGetAdvertisement = (topic, data) => {
        this.advertisementApiClient.getAdvertisement(data.advertisementId);
    };

    handleUpdateAdvertisement = (topic, data) => {
        this.advertisementApiClient.updateAdvertisement(data);
    };

    handleLoadBilling = (topic, data) => {
        const selectedMonthDateRange = Time.getMonthDateRange(data.selectedYear, data.selectedMonth);
        this.advertisementApiClient.getAdvertiserBillingForRange(
            selectedMonthDateRange[0],
            selectedMonthDateRange[1]
        );
    };

}

export default new AdvertisementActions();
